import { IApplicationState } from '../../types/redux';

export const getReliability = (state: IApplicationState) => state.developerV2?.reliability;
